'use client';

export { default } from './Backdrop';
export { default as backdropClasses } from './backdropClasses';
export * from './backdropClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Backdrop/index.js
// module id = 276
// module chunks = 22